import { Box } from 'shared';
import styled, { from } from 'theme';

import { PageWrapper } from '../Dashboard.styles';

export const ApplicationsWrapper = styled(PageWrapper)`
  .applications__column {
    margin-bottom: 2rem;
  }

  ${from('xlg')} {
    .applications__column:nth-child(odd) {
      .application {
        margin-right: 1rem;
      }
    }

    .applications__column:nth-child(even) {
      .application {
        margin-left: 1rem;
      }
    }
  }
`;

export const ApplicationPlaceholder = styled(Box)`
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  background-color: white;
  border-radius: ${props => props.theme.variables.borders.radius};
  border: 0.0625rem dashed ${props => props.theme.variables.customColors.leadingColor.base};
  color: ${props => props.theme.variables.customColors.leadingColor.base};
  font-weight: ${props => props.theme.variables.fonts.weight.medium};
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 100%;
  min-height: 11rem;

  &:hover {
    background-color: transparent;
  }

  img {
    display: block;
    width: 1.5em;
    margin-bottom: 1rem;
  }
`;

export const PageHeaderInfo = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.variables.customColors.lightNavy};
  font-family: ${props => props.theme.variables.typography.secondaryFont};
  line-height: 1.25;

  img {
    width: 1.875rem;
    margin-left: 0.75rem;
  }
`;

export const AddApplicationButton = styled(PageHeaderInfo)`
  cursor: pointer;
  color: ${props => props.theme.variables.customColors.leadingColor.base};
  font-weight: ${props => props.theme.variables.fonts.weight.bold};

  img {
    width: 1.5em;
    margin-left: 1rem;
  }
`;

export const TooltipContent = styled.div`
  max-width: 13rem;
`;
